import { createRouter } from '@tanstack/react-router';

import { queryClient } from './api/queryClient';
import { routeTree } from './routeTree.gen';
import { parseSearch, stringifySearch } from './routerSearch';

// Single router instance. The route tree is generated by
// @tanstack/router-plugin from src/routes/* — never hand-edit
// routeTree.gen.ts.
//
// `defaultPreload: 'intent'` preloads route bundles on link hover/focus
// so navigation feels instant. `defaultPreloadStaleTime: 0` lets the
// query cache decide freshness rather than the router caching the
// preloaded data twice.
//
// `parseSearch` / `stringifySearch` override the default JSON
// encoder with a repeated-key URLSearchParams encoder so multi-tag
// filters serialize as `?tag=a&tag=b` (the natural HTTP convention
// and what the FastAPI `tag?: string[]` query param consumes).
// See `routerSearch.ts` for the semantics.
export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  parseSearch,
  stringifySearch,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
